export default __webpack_public_path__ + "static/media/excmark.d6b3a074.svg";